import "./SubBlog.css";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useSelector } from "react-redux";
import { selectUserLanguage } from "../../features/user/userSlice";
import useLanguage from "../../hooks/useLanguage";
import { useState } from "react";
import carImage from "../../assets/images/car-image.png";
import Twiter from "../../assets/icons/Twiter.svg";
import Instagram from "../../assets/icons/Instagram.svg";
import LinkedIn from "../../assets/icons/LinkedIn.svg";
import logoIcon from "../../assets/icons/logo-icon.svg";

const SubBlog = () => {
  const currentLanguage = useSelector(selectUserLanguage) || "es";
  const [showMenu, setShowMenu] = useState(false);

  const texts = useLanguage(currentLanguage, "views.landingPage");

  return (
    <>
      <Header
        texts={texts}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        inLandingPage={false}
      />
      <div className="sub-blog-container">
        <div className="sub-blog-content-header"></div>
        <div className="sub-blog-content">
          <h1>¿Por qué la sustentabilidad importa hoy más que nunca?</h1>
          <div className="sub-blog-content-top">
            <div className="blog-entry-button">Sustentabilidad</div>
            <span>Julio 31, 2025</span>
          </div>
          <p>
            En la actualidad, el mundo enfrenta desafíos ambientales sin
            precedentes: el cambio climático, la contaminación de los océanos,
            la deforestación masiva y la pérdida acelerada de biodiversidad.
            Estos problemas no son solo cifras alarmantes en reportes
            científicos; tienen consecuencias directas sobre nuestras vidas:
            desde fenómenos meteorológicos extremos hasta escasez de recursos
            naturales básicos como el agua potable o los alimentos. Frente a
            este panorama, la sustentabilidad se presenta como una respuesta
            necesaria y urgente. Pero ¿qué significa realmente ser sustentable?
            Más allá de una tendencia o moda ecológica, la sustentabilidad
            implica tomar decisiones que satisfagan nuestras necesidades
            actuales sin comprometer la capacidad de las futuras generaciones
            para satisfacer las suyas. Esto abarca no solo el cuidado del medio
            ambiente, sino también el bienestar social y económico de las
            personas.
          </p>
          <img
            className="sub-blog-content-image"
            src={carImage}
            alt="car-image"
          />
          <p>
            Adoptar una vida más sustentable no requiere cambios drásticos de un
            día para otro. Se trata de pequeños gestos cotidianos que, sumados,
            pueden generar un impacto significativo. Optar por productos
            locales, reducir el uso de plásticos de un solo uso, ahorrar energía
            en casa, o incluso repensar nuestra forma de consumir, son algunas
            maneras en las que podemos empezar a actuar. También es importante
            entender que la sustentabilidad no es solo responsabilidad de los
            gobiernos o las grandes empresas. Si bien las políticas públicas y
            las acciones corporativas son cruciales, cada persona puede ser un
            agente de cambio desde su lugar. La educación, el consumo
            responsable y la participación ciudadana son herramientas poderosas
            para impulsar una transición hacia un mundo más equilibrado. Hoy más
            que nunca, el llamado es claro: necesitamos replantear la relación
            que tenemos con nuestro entorno. La sustentabilidad no es una
            opción, es el camino para garantizar un futuro habitable, justo y
            resiliente para todos.
          </p>
        </div>
        <div className="sub-blog-content-social">
          <h3>Compartir</h3>
          <div className="sub-blog-content-social-item">
            <img
              className="sub-blog-content-social-icon"
              src={Twiter}
              alt="Twiter"
            />
            <a
              href="https://x.com/amvicarpooling"
              target="_blank"
              rel="noopener noreferrer"
            >
              X (Twitter)
            </a>
          </div>
          <div className="sub-blog-content-social-item">
            <img
              className="sub-blog-content-social-icon"
              src={Instagram}
              alt="Instagram"
            />
            <a
              href="https://www.instagram.com/amvicarpooling/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </div>
          <div className="sub-blog-content-social-item">
            <img
              className="sub-blog-content-social-icon"
              src={LinkedIn}
              alt="LinkedIn"
            />
            <a
              href="https://www.linkedin.com/company/amvi-mobility/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
          </div>
          <div className="sub-blog-content-social-logo">
            <img className="icon-logo" alt="amvi logo icon" src={logoIcon} />
            <div className="sub-blog-content-social-logo-content">
              <h3>AMVI</h3>
              <p>
                En AMVI promovemos la movilidad sustentable a través del
                carpooling. Conectamos personas para reducir emisiones, tráfico
                y construir un futuro más limpio.
              </p>
            </div>
          </div>
        </div>
        <Footer inLandingPage={false} />
      </div>
    </>
  );
};

export default SubBlog;
